import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Svg from '../../common/components/Svg';

import styles from './panel-banner.scss';

import chevronSvg from '../../common/assets/icons/chevron-right.svg';

const PanelBanner = ({ leftHeadline, leftText, rightHeadline, background }) => (
  <div className={styles.container} style={{ backgroundImage: `url('${background}')` }}>
    <div className={styles.innerContainer}>
      <div className={styles.leftPanel}>
        <h2>{leftHeadline}</h2>
        <p>{leftText}</p>
      </div>

      <div className={styles.rightPanelContainer}>
        <div className={styles.rightPanel}>
          <h1>{rightHeadline}</h1>
        </div>

        <Link to="/kontakta-oss/" className={styles.cta}>
          Kontakta oss
          <Svg src={chevronSvg} className={styles.ctaChevron} />
        </Link>
      </div>
    </div>
  </div>
);

PanelBanner.propTypes = {
  leftHeadline: PropTypes.string.isRequired,
  leftText: PropTypes.string.isRequired,
  rightHeadline: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
};

export default PanelBanner;



// WEBPACK FOOTER //
// ./blocks/PanelBanner/index.js